/* eslint-disable max-len */
import React, { Component } from 'react';
import { withLocalize } from 'react-localize-redux';
import { Header } from 'semantic-ui-react';
import { Field } from 'formik';

import { Project } from '../common/constant';
import Image from '../common/image';
import { IMAGE_RESIZE } from '../network/api';
import { formatDateTime } from '../common/datetime';
import { HHContentEditor } from './fields';
import BingMaps from '../common/bingMaps';

class EventFormDisplay extends Component {
  resizeIframe = () => {
    this.iframeObj.setAttribute('style', `height: ${this.iframeObj.contentWindow.document.body.scrollHeight}px`);
  };

  render() {
    const { values, translate, activeLanguage } = this.props;

    const currentCoverImageUrl = values.bannerBg
      ? IMAGE_RESIZE('w1000', values.bannerBg)
      : Project.defaultCoverImage;

    return (
      <div className='cms-main eventDetail'>
        <div className='eventDetail_coverImage'>
          <Image style={{ maxWidth: '100%' }} src={currentCoverImageUrl} alt='uploaded file' />
        </div>
        <div className='eventDetail_header'>
          <h1 className='eventDetail_header_heading'>{values.name}</h1>
          <div className='eventDetail_header_nav'>
            <ul className='eventDetail_header_nav_list preview_li' >
              <li className='eventDetail_header_nav_list_item-details'>
                <span className='active'>{translate('details')}</span>
              </li>
            </ul>
          </div>
        </div>
        <div className='eventDetail_main'>
          <div className='eventDetail_main_detail empty'>
            <Field name='contentJson' component={HHContentEditor} maxImageSizeMB={3} />
          </div>

          <section className='eventDetail_main_infobar'>
            <div className='eventDetail_main_infobar_date'>
              <Header as='h2'>{translate('eventDate')}</Header>
              <ul className='eventDetail_main_infobar_date_list'>
                <li className='eventDetail_main_infobar_date_list_startDate'>
                  <span className='caption'>{translate('eventStart')}</span>
                  <span className='span_preview'>{formatDateTime(values.start, activeLanguage.code, values.timezone)}</span>
                </li>
                <li className='eventDetail_main_infobar_date_list_endDate'>
                  <span className='caption'>{translate('eventEnd')}</span>
                  <span>{formatDateTime(values.end, activeLanguage.code, values.timezone)}</span>
                </li>
                <li className='eventDetail_main_infobar_date_list_deadline'>
                  <span className='caption'>{translate('Submission Deadline')}</span>
                  <span>{formatDateTime(values.subDeadline, activeLanguage.code, values.timezone)}</span>
                </li>
              </ul>
            </div>

            <div className='eventDetail_main_infobar_location'>
              <Header as='h2'>{translate('location')}</Header>
              <BingMaps location={values.location} />
            </div>
          </section>
        </div>
      </div>
    );
  }
}

export default withLocalize(EventFormDisplay);



// WEBPACK FOOTER //
// ./src/components/forms/eventFormDisplay.js